module.exports = __webpack_public_path__ + "img/U2764.d34adecc.png";